import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Toolbar, Typography, OutlinedInput, InputAdornment, Grid, Stack, Chip } from '@mui/material';
// component
import { t } from 'i18next';
import { useState } from 'react';
import ProductFilterSidebarHaveGroup from './ProductFilterSidebarHaveGroup';
import Iconify from '../iconify/Iconify';
import { glb_sv } from 'src/utils';

// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
    height: 96,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
    width: { sm: '100%', lg: '50%' },
    transition: theme.transitions.create(['box-shadow', 'width'], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.shorter,
    }),
    '&.Mui-focused': {
        // width: 320,
        boxShadow: theme.customShadows.z8,
    },
    '& fieldset': {
        borderWidth: `1px !important`,
        borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
    },
}));

// ----------------------------------------------------------------------

FilterDevice.propTypes = {
    numSelected: PropTypes.number,
    filterName: PropTypes.string,
    onFilterName: PropTypes.func,
};

export default function FilterDevice({
    arrProperties = [],
    numSelected,
    filterName,
    onFilterName,
    getValue,
    setProperties,
    dataAllGroup,
    setDataAllGroup,
}) {
    const [value, setValue] = useState('');
    const [openFilter, setOpenFilter] = useState(false);
    const onChangeValue = (e) => {
        setValue(e.target.value);
        getValue && getValue(e.target.value);
    };

    // const handleSearch = (search) => {
    //     const arrSearch = listOptions.filter((data) => data.label.includes(search.toUpperCase()));
    //     setOptionNew(arrSearch);
    // };
    const handleDelete = (item, index, indexParent) => {
        console.info('You clicked the delete icon.', item, index);
        // arrProperties.splice(index, 1);
        // setArrProperties([...arrProperties]);
        if (item) {
            arrProperties[indexParent].value[index] = {
                ...arrProperties[indexParent].value[index],
                checked: !arrProperties[indexParent].value[index].checked,
            };
            setProperties([...arrProperties]);
        }
    };

    return (
        <>
            <Grid item xl={12} md={12} sm={12} padding={2}>
                {/* <StyledRoot
                    sx={{
                        ...(numSelected > 0 && {
                            color: 'primary.main',
                            bgcolor: 'primary.lighter',
                        }),
                    }}
                > */}
                <StyledSearch
                    value={value}
                    onChange={onChangeValue}
                    fullWidth
                    placeholder={t('search')}
                    startAdornment={
                        <InputAdornment position="start">
                            <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                        </InputAdornment>
                    }
                />
                {/* </StyledRoot> */}
            </Grid>
            {/* <Grid item xl={2} md={2} sm={2} display={'flex'} alignItems={'center'}>
                <ProductFilterSidebarHaveGroup
                    openFilter={openFilter}
                    valueChange={arrProperties}
                    getValue={setProperties}
                    onCloseFilter={() => setOpenFilter(false)}
                    onOpenFilter={() => setOpenFilter(true)}
                    dataAllGroup={dataAllGroup}
                    setDataAllGroup={setDataAllGroup}
                />
            </Grid> */}
{/* 
            <Stack direction="row" flexWrap={'wrap'} padding={2} spacing={1}>
                {arrProperties.length > 0 &&
                    arrProperties.map((item, index) => {
                        return (
                            <div key={index} style={{ gap: 1, margin: 1 }}>
                                {item?.value?.length > 0 &&
                                    item.value.map((value, idx) => {
                                        if (value.checked) {
                                            return (
                                                <Chip
                                                    variant="outlined"
                                                    key={idx}
                                                    sx={{ marginLeft: 1 }}
                                                    label={glb_sv.convertMultipleLanguages(value?.label)}
                                                    color="primary"
                                                    // onClick={() => handleClick(item, index)}
                                                    onDelete={() => handleDelete(item, idx, index)}
                                                />
                                            );
                                        }
                                    })}
                            </div>
                        );
                    })}
            </Stack> */}
        </>
    );
}
